import apiClient from './client';

// Auth
export const authAPI = {
  login: (username, password) =>
    apiClient.post('/auth/login/', { username, password }),
  register: (data) => apiClient.post('/auth/register/', data),
  profile: () => apiClient.get('/auth/profile/'),
  updateProfile: (data) => apiClient.put('/auth/profile/', data),
  changePassword: (data) => apiClient.post('/auth/change-password/', data),
  logout: () => apiClient.post('/auth/logout/'),
  // Gestión de usuarios (solo admin)
  listUsers: () => apiClient.get('/auth/users/'),
  createUser: (data) => apiClient.post('/auth/users/', data),
  updateUser: (id, data) => apiClient.patch(`/auth/users/${id}/`, data),
  deleteUser: (id) => apiClient.delete(`/auth/users/${id}/`),
};

// Customers
export const customersAPI = {
  list: (params) => apiClient.get('/customers/', { params }),
  create: (data) => apiClient.post('/customers/', data),
  get: (id) => apiClient.get(`/customers/${id}/`),
  update: (id, data) => apiClient.put(`/customers/${id}/`, data),
  delete: (id) => apiClient.delete(`/customers/${id}/`),
  addContact: (id, data) => apiClient.post(`/customers/${id}/add_contact/`, data),
  updateContact: (customerId, contactId, data) =>
    apiClient.patch(`/customers/${customerId}/contacts/${contactId}/`, data),
  deleteContact: (customerId, contactId) =>
    apiClient.delete(`/customers/${customerId}/contacts/${contactId}/`),
  getInvoices: (id) => apiClient.get(`/customers/${id}/invoices/`),
};

// Invoices
export const invoicesAPI = {
  list: (params) => apiClient.get('/invoices/', { params }),
  create: (data) => apiClient.post('/invoices/', data),
  get: (id) => apiClient.get(`/invoices/${id}/`),
  update: (id, data) => apiClient.put(`/invoices/${id}/`, data),
  delete: (id) => apiClient.delete(`/invoices/${id}/`),
  overdue: () => apiClient.get('/invoices/overdue/'),
  dueSoon: () => apiClient.get('/invoices/due_soon/'),
  pending: () => apiClient.get('/invoices/pending/'),
  markAsIssued: (id) => apiClient.post(`/invoices/${id}/mark_as_issued/`),
};

// Payments
export const paymentsAPI = {
  list: (params) => apiClient.get('/payments/', { params }),
  create: (data) => apiClient.post('/payments/', data),
  get: (id) => apiClient.get(`/payments/${id}/`),
  update: (id, data) => apiClient.put(`/payments/${id}/`, data),
  delete: (id) => apiClient.delete(`/payments/${id}/`),
};

// Portfolio
export const portfolioAPI = {
  getAnalysis: (params) => apiClient.get('/portfolio/analysis/', { params }),
  getReports: (params) => apiClient.get('/portfolio/reports/', { params }),
};

// Mailing
export const mailingAPI = {
  // Templates
  listTemplates: (params) => apiClient.get('/mailing/templates/', { params }),
  createTemplate: (data) => apiClient.post('/mailing/templates/', data),
  getTemplate: (id) => apiClient.get(`/mailing/templates/${id}/`),
  updateTemplate: (id, data) => apiClient.put(`/mailing/templates/${id}/`, data),
  deleteTemplate: (id) => apiClient.delete(`/mailing/templates/${id}/`),
  previewTemplate: (id, data) => apiClient.post(`/mailing/templates/${id}/preview/`, data),
  sendTestEmail: (id, data) => apiClient.post(`/mailing/templates/${id}/send_test/`, data),

  // Scheduled Emails
  listScheduled: (params) => apiClient.get('/mailing/scheduled/', { params }),
  createScheduled: (data) => apiClient.post('/mailing/scheduled/', data),
  getScheduled: (id) => apiClient.get(`/mailing/scheduled/${id}/`),
  updateScheduled: (id, data) => apiClient.put(`/mailing/scheduled/${id}/`, data),
  deleteScheduled: (id) => apiClient.delete(`/mailing/scheduled/${id}/`),

  // Email Logs
  listLogs: (params) => apiClient.get('/mailing/logs/', { params }),
  getLog: (id) => apiClient.get(`/mailing/logs/${id}/`),
};

// Rules
export const rulesAPI = {
  list: (params) => apiClient.get('/rules/', { params }),
  create: (data) => apiClient.post('/rules/', data),
  get: (id) => apiClient.get(`/rules/${id}/`),
  update: (id, data) => apiClient.put(`/rules/${id}/`, data),
  delete: (id) => apiClient.delete(`/rules/${id}/`),
  listExecutions: (params) => apiClient.get('/rules/executions/', { params }),
};
